function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useCallback, useEffect, useState } from 'react';
import omit from 'lodash.omit';
import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import IsNotSaved from '../IsNotSaved';
import useUpdateState from '../hooks/useUpdateState';
import { useErrorHandling } from '@rd-web-markets/shared/dist/hooks/useErrorHandling';
import EligibleExpenseRow from './EligibleExpenseRow';
import generalRouteSubRouteService from '@rd-web-markets/shared/dist/services/general_route_subroute.service';
const listVersion7 = [{
  name: 'eligible_expenses_from_wages_own_employees_before_jul_2020',
  translationKey: 'eligible_expenses_from_wages_own_employees_before_jul_2020'
}, {
  name: 'declared_working_hours_sole_proprietor_before_jul_2020',
  translationKey: 'declared_working_hours_sole_proprietor_before_jul_2020'
}, {
  name: 'max_eligible_hours_sole_proprietor_before_jul_2020',
  translationKey: 'max_eligible_hours_sole_proprietor_before_jul_2020'
}, {
  name: 'declared_working_hours_co_entrepreneurship_partners_before_jul_2020',
  translationKey: 'declared_working_hours_co_entrepreneurship_partners_before_jul_2020'
}, {
  name: 'max_eligible_hours_co_entrepreneurship_partners_before_jul_2020',
  translationKey: 'max_eligible_hours_co_entrepreneurship_partners_before_jul_2020'
}, {
  name: 'total_eligible_expenses_own_contributions_before_jul_2020',
  translationKey: 'total_eligible_expenses_own_contributions_before_jul_2020'
}, {
  name: 'total_remuneration_contract_research_before_jul_2020',
  translationKey: 'total_remuneration_contract_research_before_jul_2020'
}, {
  name: 'contract_research_sixty_percent_eligible_before_jul_2020',
  translationKey: 'of_which_sixty_percent_eligible'
}, {
  name: 'subtotal_eligible_expenses_before_jul_2020',
  translationKey: 'subtotal_eligible_expenses_before_jul_2020'
}, {
  name: 'eligible_expenses_from_wages_own_employees_after_jun_2020',
  translationKey: 'eligible_expenses_from_wages_own_employees_after_jun_2020'
}, {
  name: 'declared_working_hours_sole_proprietor_after_jun_2020',
  translationKey: 'declared_working_hours_sole_proprietor_after_jun_2020'
}, {
  name: 'max_eligible_hours_sole_proprietor_after_jun_2020',
  translationKey: 'max_eligible_hours_sole_proprietor_after_jun_2020'
}, {
  name: 'declared_working_hours_co_entrepreneurship_partners_after_jun_2020',
  translationKey: 'declared_working_hours_co_entrepreneurship_partners_after_jun_2020'
}, {
  name: 'max_eligible_hours_co_entrepreneurship_partners_after_jun_2020',
  translationKey: 'max_eligible_hours_co_entrepreneurship_partners_after_jun_2020'
}, {
  name: 'total_eligible_expenses_own_contributions_after_jun_2020',
  translationKey: 'total_eligible_expenses_own_contributions_after_jun_2020'
}, {
  name: 'total_remuneration_contract_research_after_jun_2020',
  translationKey: 'total_remuneration_contract_research_after_jun_2020'
}, {
  name: 'contract_research_sixty_percent_eligible_after_jun_2020',
  translationKey: 'of_which_sixty_percent_eligible'
}, {
  name: 'subtotal_eligible_expenses_after_jun_2020',
  translationKey: 'subtotal_eligible_expenses_after_jun_2020'
}, {
  name: 'eligible_expenses_before_jul_2020_capped_at_2m',
  translationKey: 'eligible_expenses_before_jul_2020_capped_at_2m'
}, {
  name: 'total_eligible_expenses_before_jul_2020_and_after_jun_2020',
  translationKey: 'total_eligible_expenses_before_jul_2020_and_after_jun_2020'
}, {
  name: 'eligible_assessment_basis_capped_at_4m',
  translationKey: 'eligible_assessment_basis_capped_at_4m'
}, {
  name: 'requested_research_allowance',
  translationKey: 'requested_research_allowance'
}];
const listVersion8 = [{
  name: 'eligible_expenses_from_wages_own_employees_before_mar_2024',
  translationKey: 'eligible_expenses_from_wages_own_employees_before_mar_2024'
}, {
  name: 'declared_working_hours_sole_proprietor_before_mar_2024',
  translationKey: 'declared_working_hours_sole_proprietor_before_mar_2024'
}, {
  name: 'max_eligible_hours_sole_proprietor_before_mar_2024',
  translationKey: 'max_eligible_hours_sole_proprietor_before_mar_2024'
}, {
  name: 'declared_working_hours_co_entrepreneurship_partners_before_mar_2024',
  translationKey: 'declared_working_hours_co_entrepreneurship_partners_before_mar_2024'
}, {
  name: 'max_eligible_hours_co_entrepreneurship_partners_before_mar_2024',
  translationKey: 'max_eligible_hours_co_entrepreneurship_partners_before_mar_2024'
}, {
  name: 'total_eligible_expenses_own_contributions_before_mar_2024',
  translationKey: 'total_eligible_expenses_own_contributions_before_mar_2024'
}, {
  name: 'total_remuneration_contract_research_before_mar_2024',
  translationKey: 'total_remuneration_contract_research_before_mar_2024'
}, {
  name: 'contract_research_sixty_percent_eligible_before_mar_2024',
  translationKey: 'of_which_sixty_percent_eligible'
}, {
  name: 'subtotal_eligible_expenses_before_mar_2024',
  translationKey: 'subtotal_eligible_expenses_before_mar_2024'
}, {
  name: 'eligible_expenses_from_wages_own_employees_after_mar_2024',
  translationKey: 'eligible_expenses_from_wages_own_employees_after_mar_2024'
}, {
  name: 'declared_working_hours_sole_proprietor_after_mar_2024',
  translationKey: 'declared_working_hours_sole_proprietor_after_mar_2024'
}, {
  name: 'max_eligible_hours_sole_proprietor_after_mar_2024',
  translationKey: 'max_eligible_hours_sole_proprietor_after_mar_2024'
}, {
  name: 'declared_working_hours_co_entrepreneurship_partners_after_mar_2024',
  translationKey: 'declared_working_hours_co_entrepreneurship_partners_after_mar_2024'
}, {
  name: 'max_eligible_hours_co_entrepreneurship_partners_after_mar_2024',
  translationKey: 'max_eligible_hours_co_entrepreneurship_partners_after_mar_2024'
}, {
  name: 'total_eligible_expenses_own_contributions_after_mar_2024',
  translationKey: 'total_eligible_expenses_own_contributions_after_mar_2024'
}, {
  name: 'total_depreciable_assets_acquisition_production_cost_difference_after_mar_2024',
  translationKey: 'total_depreciable_assets_acquisition_production_cost_difference_after_mar_2024'
}, {
  name: 'total_depreciable_assets_prior_year_end_value_difference_after_mar_2024',
  translationKey: 'total_depreciable_assets_prior_year_end_value_difference_after_mar_2024'
}, {
  name: 'total_remuneration_contract_research_after_mar_2024',
  translationKey: 'total_remuneration_contract_research_after_mar_2024'
}, {
  name: 'contract_research_sixty_percent_eligible_contract_awarded_before_mar_2024',
  translationKey: 'contract_research_sixty_percent_eligible_contract_awarded_before_mar_2024'
}, {
  name: 'contract_research_seventy_percent_eligible_contract_awarded_after_mar_2024',
  translationKey: 'contract_research_seventy_percent_eligible_contract_awarded_after_mar_2024'
}, {
  name: 'subtotal_eligible_expenses_after_mar_2024',
  translationKey: 'subtotal_eligible_expenses_after_mar_2024'
}, {
  name: 'eligible_expenses_before_mar_2024_capped_at_4m',
  translationKey: 'eligible_expenses_before_mar_2024_capped_at_4m'
}, {
  name: 'total_eligible_expenses_before_mar_2024_and_after_mar_2024',
  translationKey: 'total_eligible_expenses_before_mar_2024_and_after_mar_2024'
}, {
  name: 'eligible_assessment_basis_capped_at_10m',
  translationKey: 'eligible_assessment_basis_capped_at_10m'
}, {
  name: 'sme_criteria_met_increased_funding_rate_applied_after_mar_2024',
  translationKey: 'sme_criteria_met_increased_funding_rate_applied_after_mar_2024'
}, {
  name: 'requested_research_allowance',
  translationKey: 'requested_research_allowance'
}];
const yesNoFieldsVersion8 = ['sme_criteria_met_increased_funding_rate_applied_after_mar_2024'];
const EligibleExpenses = _ref => {
  let {
    financialYear,
    search,
    elsterId,
    elster
  } = _ref;
  const {
    t
  } = useTranslation();
  const [isNotSaved, setIsNotSaved] = useState(false);
  const [eligibleExpenses, setEligibleExpenses] = useState(null);
  const [updateState] = useUpdateState(setEligibleExpenses, setIsNotSaved);
  useEffect(() => {
    const mainTab = new URLSearchParams(search).get('main_tab');
    if (!elsterId || mainTab !== 'summary') return;
    (async () => {
      const response = await generalRouteSubRouteService.getAll(elsterId, 'elsters', 'eligible_expense');
      setEligibleExpenses(_objectSpread({}, response));
    })();
  }, [elsterId, search, setEligibleExpenses]);
  const saveData = useErrorHandling(useCallback(async body => {
    const fieldValues = omit(body, ['id', 'elster_id', 'created_at', 'updated_at']);
    if (Object.values(fieldValues).some(value => value < 0)) {
      throw new Error('Values must be greater than 0');
    }
    const response = await generalRouteSubRouteService.update(body.elster_id, 'elsters', 'eligible_expense', '', body);
    setEligibleExpenses(_objectSpread({}, response));
    setIsNotSaved(false);
  }, [setEligibleExpenses]));
  if (!eligibleExpenses) return /*#__PURE__*/React.createElement("div", null, t('loading...'));
  const isVersion8 = (elster === null || elster === void 0 ? void 0 : elster.version_number) === 'version_8';
  const list = isVersion8 ? listVersion8 : listVersion7;
  const yesNoFields = isVersion8 ? yesNoFieldsVersion8 : [];
  const eligibleExpensesRows = list.map((field, index) => /*#__PURE__*/React.createElement(EligibleExpenseRow, {
    rowData: [field.name, eligibleExpenses.calculations[field.name]],
    translationKey: field.translationKey,
    index: index,
    updateState: updateState,
    eligibleExpenses: eligibleExpenses,
    key: field.name + 'rowData',
    disabled: true,
    isYesNoField: yesNoFields.includes(field.name),
    isVersion8: isVersion8
  }));
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Row, {
    className: "mb-3"
  }, /*#__PURE__*/React.createElement(Col, {
    md: 7
  }, t('determination_of_eligible_expenses_from_wages')), /*#__PURE__*/React.createElement(Col, {
    md: 5
  })), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    md: 7
  }, t('financial_year')), /*#__PURE__*/React.createElement(Col, {
    md: 5
  }, financialYear)), eligibleExpensesRows, /*#__PURE__*/React.createElement("hr", null));
};
export default EligibleExpenses;